import revive_payload_client_4sVQNw7RlN from "/builds/sites/wnhub-general-client/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/sites/wnhub-general-client/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/sites/wnhub-general-client/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/sites/wnhub-general-client/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/sites/wnhub-general-client/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/builds/sites/wnhub-general-client/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/builds/sites/wnhub-general-client/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/sites/wnhub-general-client/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_yfWm7jX06p from "/builds/sites/wnhub-general-client/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/builds/sites/wnhub-general-client/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import index_client_eR9yRz2wh7 from "/builds/sites/wnhub-general-client/plugins/google-tag/index.client.ts";
import index_client_hqxuQKR3i7 from "/builds/sites/wnhub-general-client/plugins/yandex-metrika/index.client.ts";
import index_client_DlZOoMy7n8 from "/builds/sites/wnhub-general-client/plugins/facebook-pixel/index.client.ts";
import index_client_OVUR3Jm8gr from "/builds/sites/wnhub-general-client/plugins/vk-pixel/index.client.ts";
import index_client_whjAqf42nr from "/builds/sites/wnhub-general-client/plugins/linkedin-tag/index.client.ts";
import index_client_3gN8gdLgZR from "/builds/sites/wnhub-general-client/plugins/cityads-pixel/index.client.ts";
import index_client_azuhZUm6fP from "/builds/sites/wnhub-general-client/plugins/hh-career/index.client.ts";
import marked_J1GOfrXx02 from "/builds/sites/wnhub-general-client/plugins/marked.ts";
import _02_sentry_client_sABltX8K3S from "/builds/sites/wnhub-general-client/plugins/02.sentry.client.ts";
import clickaway_ZmIhydr7La from "/builds/sites/wnhub-general-client/plugins/clickaway.ts";
import dayjs_pGiXRjcsJO from "/builds/sites/wnhub-general-client/plugins/dayjs.ts";
import global_2XP5sjpyNs from "/builds/sites/wnhub-general-client/plugins/global.ts";
import native_qKW9h7phCr from "/builds/sites/wnhub-general-client/plugins/native.ts";
import vee_validate_KcKlKmvCrJ from "/builds/sites/wnhub-general-client/plugins/vee-validate.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  index_client_eR9yRz2wh7,
  index_client_hqxuQKR3i7,
  index_client_DlZOoMy7n8,
  index_client_OVUR3Jm8gr,
  index_client_whjAqf42nr,
  index_client_3gN8gdLgZR,
  index_client_azuhZUm6fP,
  marked_J1GOfrXx02,
  _02_sentry_client_sABltX8K3S,
  clickaway_ZmIhydr7La,
  dayjs_pGiXRjcsJO,
  global_2XP5sjpyNs,
  native_qKW9h7phCr,
  vee_validate_KcKlKmvCrJ
]